import {SystemsPage} from "../features/database/SystemsPage"

export default SystemsPage